var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import * as React from "react";
import { ThemeContext } from "styled-components";
import { fadeColor, getColor, saturationColor } from "../helpers/ColorHelpers";
import { appendPx, calcHeightMinusPadding, calculateComponentDefinition, getSizeAsNumber, getThemeEntry, scalePadding, scaleSize } from "../theme/DefaultTheme";
import { styled } from "../theme/ThemeHelpers";
import Icon from "./Icon";
export function getButtonDefinition(p, f) {
    var b = p.theme.buttons[f];
    if (b)
        return b;
    var m = p.theme.menus[f];
    if (m)
        return m;
    if (!b) {
        var c = p.theme.components && p.theme.components[f] ? p.theme.components[f] : undefined;
        if (c) {
            var def = calculateComponentDefinition(p, c);
            return def;
        }
    }
    return b;
}
export function buttonBackgroundColor(p, f) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button)
        return getColor(p, button.backgroundColor);
    return "transparent";
}
export function buttonColor(p, f) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button)
        return getColor(p, button.color);
    return "transparent";
}
export function buttonHoverBackgroundColor(p, f, fadePerc) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button) {
        if (button.hoverColor)
            return getColor(p, button.hoverColor.backgroundColor);
        else
            return fadeColor(p, button.backgroundColor, fadePerc ? fadePerc : (p.theme.buttons.hoverFadePercentag ? p.theme.buttons.hoverFadePercentag : 30));
    }
    return "transparent";
}
export function buttonHoverColor(p, f, fadePerc) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button) {
        if (button.hoverColor)
            return getColor(p, button.hoverColor.color);
        else
            return fadeColor(p, button.backgroundColor, fadePerc ? fadePerc : (p.theme.buttons.hoverFadePercentag ? p.theme.buttons.hoverFadePercentag : 30));
    }
    return "transparent";
}
export function buttonDisabledBackgroundColor(p, f, satFact) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button) {
        if (button.disabledColor)
            return getColor(p, button.disabledColor.backgroundColor);
        else
            return saturationColor(p, button.backgroundColor, satFact ? satFact : (p.theme.buttons.disabledSaturationFactor ? p.theme.buttons.disabledSaturationFactor : 0.25));
    }
    return "transparent";
}
export function buttonDisabledColor(p, f, satFact) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button) {
        if (button.disabledColor)
            return getColor(p, button.disabledColor.color);
        else
            return saturationColor(p, button.color, satFact ? satFact : (p.theme.buttons.disabledSaturationFactor ? p.theme.buttons.disabledSaturationFactor : 0.25));
    }
    return "transparent";
}
export function buttonActiveBackgroundColor(p, f, fadePerc) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button) {
        if (button.activeColor)
            return getColor(p, button.activeColor.backgroundColor);
        else
            return fadeColor(p, button.backgroundColor, fadePerc ? fadePerc : (p.theme.buttons.activeFadePercentage ? p.theme.buttons.activeFadePercentage : 50));
    }
    return "transparent";
}
export function buttonActiveColor(p, f, fadePerc) {
    var button = typeof f === "function" ? getThemeEntry(p, f) : getButtonDefinition(p, f);
    if (button) {
        if (button.activeColor)
            return getColor(p, button.activeColor.color);
        else
            return fadeColor(p, button.backgroundColor, fadePerc ? fadePerc : (p.theme.buttons.activeFadePercentage ? p.theme.buttons.activeFadePercentage : 50));
    }
    return "transparent";
}
//${props => props.active ? buttonHoverBackgroundColor(props, props.kind) : (props.disabled ? buttonDisabledBackgroundColor(props, props.kind) : buttonBackgroundColor(props, props.kind))};
export function getButtonBackgroundColor(props, f) {
    if (props.bordered)
        return "transparent"; // props.active ? buttonActiveColor(props, props.kind) : (props.disabled ? buttonDisabledColor(props, props.kind) : buttonColor(props, props.kind));
    else
        return props.active ? buttonActiveBackgroundColor(props, props.kind) : (props.disabled ? buttonDisabledBackgroundColor(props, props.kind) : buttonBackgroundColor(props, props.kind));
}
export function getButtonColor(props, f) {
    if (props.bordered)
        return props.active ? buttonActiveBackgroundColor(props, props.kind) : (props.disabled ? buttonDisabledBackgroundColor(props, props.kind) : buttonBackgroundColor(props, props.kind));
    else
        return props.active ? buttonActiveColor(props, props.kind) : (props.disabled ? buttonDisabledColor(props, props.kind) : buttonColor(props, props.kind));
}
export function getButtonHoverBackgroundColor(props, f) {
    if (props.bordered)
        return "transparent"; //  props.active ? buttonActiveColor(props, props.kind) :  (props.disabled ? buttonDisabledColor(props, props.kind) :  buttonHoverColor(props, props.kind));
    else
        return props.active ?
            buttonActiveBackgroundColor(props, props.kind) :
            (props.disabled ? buttonDisabledBackgroundColor(props, props.kind) :
                buttonHoverBackgroundColor(props, props.kind));
}
export function getButtonHoverColor(props, f) {
    if (props.bordered)
        return props.active ?
            buttonActiveBackgroundColor(props, props.kind) :
            (props.disabled ? buttonDisabledBackgroundColor(props, props.kind) :
                buttonHoverBackgroundColor(props, props.kind));
    else
        return props.active ?
            buttonActiveColor(props, props.kind) :
            (props.disabled ? buttonDisabledColor(props, props.kind) :
                buttonHoverColor(props, props.kind));
}
var defaultSizes = {
    buttonHeight: 40,
    fontSize: 14,
    iconSize: 18,
    padding: 4,
    paddingBordered: 3,
    contentPaddingWithIcon: "6px 8px 4px 0px",
    contentPaddingWithoutIcon: "6px 8px",
    iconMarginTop: 3,
};
var calcSizes = function (factor) {
    return {
        buttonHeight: scaleSize(defaultSizes.buttonHeight, factor),
        fontSize: scaleSize(defaultSizes.fontSize, factor),
        iconSize: scaleSize(defaultSizes.iconSize, factor),
        padding: scalePadding(defaultSizes.padding, factor),
        paddingBordered: scalePadding(defaultSizes.paddingBordered, factor),
        contentPaddingWithIcon: scalePadding(defaultSizes.contentPaddingWithIcon, factor),
        contentPaddingWithoutIcon: scalePadding(defaultSizes.contentPaddingWithoutIcon, factor),
        iconMarginTop: scaleSize(defaultSizes.iconMarginTop, factor),
    };
};
var standard = {
    mini: calcSizes(25 / defaultSizes.buttonHeight),
    small: calcSizes(32 / defaultSizes.buttonHeight),
    default: defaultSizes,
    large: calcSizes(50 / defaultSizes.buttonHeight),
};
export function getButtonSizes(theme, s) {
    var size = s !== null && s !== void 0 ? s : "default";
    var cur = standard[size];
    if (theme.buttonSizes) {
        var ts = theme.buttonSizes;
        var bs = ts[size];
        if (bs) {
            var toRet_1 = _.clone(cur);
            _.forEach(bs, function (val, key) {
                if (val)
                    toRet_1[key] = val;
            });
            return toRet_1;
        }
    }
    return cur;
}
export var calcScaleFactor = function (theme, curSizes) {
    var def = getButtonSizes(theme, "default");
    return getSizeAsNumber(curSizes.buttonHeight) / getSizeAsNumber(def.buttonHeight);
};
export var ButtonContainer = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    height: ", ";    \n    padding: ", ";\n    border: ", ";\n    width: ", ";\n    border-color: ", ";\n    stroke: ", ";\n        outline: none;\n    &:focus {\n        outline: none;\n    }\n    &:hover{\n        background-color: ", ";\n        color: ", ";\n        border: ", ";\n        border-color: ", ";\n        stroke: ", ";\n    }\n"], ["\n    font-family: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    height: ", ";    \n    padding: ", ";\n    border: ", ";\n    width: ", ";\n    border-color: ", ";\n    stroke: ", ";\n        outline: none;\n    &:focus {\n        outline: none;\n    }\n    &:hover{\n        background-color: ", ";\n        color: ", ";\n        border: ", ";\n        border-color: ", ";\n        stroke: ", ";\n    }\n"])), function (p) { return p.theme.fontFamily; }, function (props) { return getButtonBackgroundColor(props, props.kind); }, function (props) { return getButtonColor(props, props.kind); }, function (props) { return appendPx(props.sizes.fontSize); }, function (props) { return appendPx(props.sizes.buttonHeight); }, function (props) { return props.bordered ? appendPx(props.sizes.paddingBordered) : appendPx(props.sizes.padding); }, function (props) { return props.bordered ? "1px solid" : "none"; }, function (props) { return props.fluid ? "100%" : props.content ? "fit-content" : appendPx(props.sizes.buttonHeight); }, function (props) { return getButtonColor(props, props.kind); }, function (props) { return getButtonColor(props, props.kind); }, function (props) { return getButtonHoverBackgroundColor(props, props.kind); }, function (props) { return getButtonHoverColor(props, props.kind); }, function (props) { return props.bordered ? "1px solid" : "none"; }, function (props) { return getButtonHoverColor(props, props.kind); }, function (props) { return getButtonHoverColor(props, props.kind); });
export var InnerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    display: -ms-grid;\n    height: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    grid-template-columns: ", ";\n    -ms-grid-columns: ", ";\n    outline: none;\n"], ["\n    display: grid;\n    display: -ms-grid;\n    height: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    grid-template-columns: ", ";\n    -ms-grid-columns: ", ";\n    outline: none;\n"])), function (props) { return appendPx(props.height); }, function (props) { return appendPx(props.fontSize); }, function (props) { return appendPx(scaleSize(props.fontSize, 1.41)); }, function (props) { return props.gridColumnDef; }, function (props) { return props.gridColumnDef; });
export var IconContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    grid-row:1;\n    -ms-grid-column:  ", ";\n    grid-column:  ", ";\n    padding: ", ";\n    /* stroke:none; */\n"], ["\n    grid-row:1;\n    -ms-grid-column:  ", ";\n    grid-column:  ", ";\n    padding: ", ";\n    /* stroke:none; */\n"])), function (props) { return props.col; }, function (props) { return props.col; }, function (props) { var _a; return appendPx((_a = props.padding) !== null && _a !== void 0 ? _a : 0); });
export var ContentContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    grid-row:1;\n    -ms-grid-column: ", ";\n    grid-column: ", ";\n    padding: ", ";\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n"], ["\n    grid-row:1;\n    -ms-grid-column: ", ";\n    grid-column: ", ";\n    padding: ", ";\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n"])), function (props) { return props.col; }, function (props) { return props.col; }, function (props) { var _a; return appendPx((_a = props.padding) !== null && _a !== void 0 ? _a : 0); });
var ContentCentered = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    grid-row:1;\n    -ms-grid-column:  2;\n    grid-column:  2;\n    text-align:center;\n    width:100%;\n    padding: ", ";\n    display: flex; \n    justify-content: center; \n    align-items: center;\n"], ["\n    grid-row:1;\n    -ms-grid-column:  2;\n    grid-column:  2;\n    text-align:center;\n    width:100%;\n    padding: ", ";\n    display: flex; \n    justify-content: center; \n    align-items: center;\n"])), function (props) { var _a; return appendPx((_a = props.padding) !== null && _a !== void 0 ? _a : 0); });
export function getButtonColumnsAndGridDefintion(theme, buttonDefinition, hasContent, hasIcon, size) {
    var _a;
    var gridColumnDef = "";
    var icol = 1;
    var ccol = 2;
    var contentAlignment = (_a = buttonDefinition === null || buttonDefinition === void 0 ? void 0 : buttonDefinition.contentAlignment) !== null && _a !== void 0 ? _a : theme.buttons.contentAlignment;
    if (!hasIcon) {
        gridColumnDef = "auto";
        ccol = 1;
    }
    else {
        if (contentAlignment === "right") {
            gridColumnDef = "auto " + appendPx(size);
            icol = 2;
            ccol = 1;
        }
        else if (contentAlignment === "center" || contentAlignment === "justify") {
            gridColumnDef = "1fr " + appendPx(size) + " max-content 1fr";
            icol = 2;
            ccol = 3;
        }
        else {
            gridColumnDef = appendPx(size) + " max-content";
        }
    }
    return { iconColumn: icol, contentColumn: ccol, gridColumnDefinition: gridColumnDef, textAlign: contentAlignment };
}
var InnerButton = React.memo(function (props) {
    var _a, _b, _c;
    var theme = React.useContext(ThemeContext);
    var bdef = getButtonDefinition({ theme: theme }, props.kind);
    var sizes = getButtonSizes(theme, props.size);
    var height = calcHeightMinusPadding(sizes.buttonHeight, props.bordered ? sizes.paddingBordered : sizes.padding);
    var defs = getButtonColumnsAndGridDefintion(theme, bdef, props.content !== undefined, props.icon !== undefined, height);
    return (React.createElement(ButtonContainer, __assign({}, props, { sizes: sizes, style: { cursor: props.disabled ? "default" : "pointer", float: (_a = props.floated) !== null && _a !== void 0 ? _a : undefined, textAlign: defs.textAlign } }),
        React.createElement(InnerContainer, { height: height, gridColumnDef: defs.gridColumnDefinition, fontSize: sizes.fontSize },
            props.icon &&
                React.createElement(IconContainer, { padding: (_b = props.iconPadding) !== null && _b !== void 0 ? _b : sizes.padding, col: defs.iconColumn },
                    React.createElement(Icon, { inheritColor: true, name: props.icon, size: sizes.iconSize, marginTop: sizes.iconMarginTop })),
            props.content &&
                React.createElement(ContentContainer, { padding: (_c = props.contentPadding) !== null && _c !== void 0 ? _c : (props.icon ? sizes.contentPaddingWithIcon : sizes.contentPaddingWithoutIcon), col: defs.contentColumn }, props.content))));
});
var Button = React.memo(function (props) {
    var _a;
    return (props.asHtmlLinkToRoute ?
        React.createElement("a", { href: props.asHtmlLinkToRoute, target: (_a = props.asHtmlLinkToRouteTarget) !== null && _a !== void 0 ? _a : "_self", download: props.asHtmlLinkDownload },
            React.createElement(InnerButton, __assign({}, props)))
        :
            React.createElement(InnerButton, __assign({}, props)));
});
export default Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Button.js.map